import type { MaybeRefOrGetter } from "vue";

import { type V4HSiteId } from "@/data/common/ids";

const query = {
  api: "site-programming-range",
  type: "query",
} as const;

export const SiteProgrammingRangeQueryKeys = {
  all: [query] as const,
  findPlanning: (siteId: MaybeRefOrGetter<V4HSiteId>) =>
    [...SiteProgrammingRangeQueryKeys.all, siteId, { action: "find-planning" }] as const,
};
